import { createSingleEntityStore } from '@core/ngrx-legacy';

import { EmailTemplatesAssignedJobTemplatesList, EntityStoreKey } from '../../types';

const { actions, selectors, reducer, namespace } =
  createSingleEntityStore<EmailTemplatesAssignedJobTemplatesList>()(
    EntityStoreKey.EmailTemplatesAssignedJobTemplates,
    {
      customActions: adapter => ({
        fetch: (
          state,
          payload: { id: number; searchParams: { q: string | null; page: number; limit: number } },
        ) => adapter.markAsPending(state),
      }),
    },
  );

export {
  actions as EmailTemplatesAssignedJobTemplatesActions,
  selectors as EmailTemplatesAssignedJobTemplatesSelectors,
  reducer as EmailTemplatesAssignedJobTemplatesReducer,
  namespace as EmailTemplatesAssignedJobTemplatesNamespace,
};
